import "./DienLuc.css";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,

  PieChart,
  Pie,
  Cell,
} from "recharts";

const chartData = [
  { month: "Tháng 1",  "Năm 2023": 620000,  "Năm 2024": 800000 },
  { month: "Tháng 2",  "Năm 2023": 740000,  "Năm 2024": 980000 },
  { month: "Tháng 3",  "Năm 2023": 780000,  "Năm 2024": 1080000 },
  { month: "Tháng 4",  "Năm 2023": 920000,  "Năm 2024": 1260000 },
  { month: "Tháng 5",  "Năm 2023": 1159680, "Năm 2024": 1258450 },

  { month: "Tháng 6",  "Năm 2023": 980000,  "Năm 2024": 1180000 },
  { month: "Tháng 7",  "Năm 2023": 1010000, "Năm 2024": 1200000 },
  { month: "Tháng 8",  "Năm 2023": 1040000, "Năm 2024": 1220000 },
  { month: "Tháng 9",  "Năm 2023": 1060000, "Năm 2024": 1240000 },
  { month: "Tháng 10", "Năm 2023": 1080000, "Năm 2024": 1260000 },
  { month: "Tháng 11", "Năm 2023": 1100000, "Năm 2024": 1280000 },
  { month: "Tháng 12", "Năm 2023": 1120000, "Năm 2024": 1300000 }
];


const rawData = [
  {
    name: "Sinh hoạt",
    value: 1512,
    color: "#2563EB"
  },
  {
    name: "Sản xuất - KD",
    value: 428,
    color: "#14B8A6"
  },
  {
    name: "Hành chính sự nghiệp",
    value: 138,
    color: "#F59E0B"
  },
  {
    name: "Chiếu sáng công cộng",
    value: 78,
    color: "#EF4444"
  }
];

const total = rawData.reduce((sum, item) => sum + item.value, 0);

const pieData = rawData.map(item => ({
  ...item,
  percent: ((item.value / total) * 100).toFixed(1)
}));

function DienLuc() {
  return (
    <div className="bao-cao-cong-nghiep-page">

      {/* HEADER */}
      <div className="page-header">
        <div>
          <h1>Báo cáo cung cấp điện</h1>

<div className="breadcrumb">
    Trang chủ &gt; Điện lực &gt; Báo cáo cung cấp điện
</div>
        </div>

        <button className="guide-btn">
          Hướng dẫn
        </button>
      </div>

{/* FILTER */}
<div className="filter-card">

    <div className="filter-grid">

        <div className="form-group">
            <label>
                Kỳ báo cáo <span>*</span>
            </label>

            <select>
                <option>Tháng 05/2024</option>
            </select>
        </div>

        <div className="form-group">
            <label>
                Từ ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-01"
            />
        </div>

        <div className="form-group">
            <label>
                Đến ngày <span>*</span>
            </label>

            <input
                type="date"
                defaultValue="2024-05-31"
            />
        </div>

        <div className="form-group">
            <label>
                Đơn vị báo cáo <span>*</span>
            </label>

            <select>
                <option>Xã Mỹ Đức</option>
            </select>
        </div>

        <div className="filter-btn-wrapper">
            <button className="load-btn">
                Lấy dữ liệu
            </button>
        </div>

    </div>

</div>

      {/* CONTENT */}
      <div className="report-layout">

        {/* LEFT */}
        <div className="main-content">

<div className="kpi-grid">

    <div className="kpi-card">
        <div className="kpi-icon blue">
            <i className="fa-solid fa-plug"></i>
        </div>

        <div className="kpi-content">
            <h4>Điện thương phẩm (kWh)</h4>
            <h2>1.258.450</h2>
            <p>↑ 8,6% so với kỳ trước</p>
        </div>
    </div>

    <div className="kpi-card">
        <div className="kpi-icon green">
            <i className="fa-solid fa-map"></i>
        </div>

        <div className="kpi-content">
            <h4>Số khách hàng</h4>
            <h2>2.156</h2>
            <p>↑ 3,2% so với kỳ trước</p>
        </div>
    </div>

    <div className="kpi-card">
        <div className="kpi-icon orange">
            <i className="fa-solid fa-bolt"></i>
        </div>

        <div className="kpi-content">
            <h4>Tổn thất điện năng (%)</h4>
            <h2>3,45</h2>
            <p style={{color:"#DC2626"}}>
                ↓ 0,25% so với kỳ trước
            </p>
        </div>
    </div>

    <div className="kpi-card">
        <div className="kpi-icon purple">
            <i className="fa-solid fa-bell"></i>
        </div>

        <div className="kpi-content">
            <h4>Sự cố mất điện</h4>
            <h2>2</h2>
            <p>↓ 33,3% so với kỳ trước</p>
        </div>
    </div>

</div>

          {/* CHART */}
          <div className="chart-grid">

            <div className="card">

    <div className="chart-header">

        <h3>
    SẢN LƯỢNG ĐIỆN THƯƠNG PHẨM
    <span>(kWh)</span>
</h3>

    </div>

    <div className="bar-chart-wrapper">

        <ResponsiveContainer
            width="100%"
            height={260}
        >
            <BarChart data={chartData}>

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip />

                <Legend />

                <Bar
                    dataKey="Năm 2023"
                    fill="#9EC5FE"
                    radius={[4,4,0,0]}
                />

                <Bar
                    dataKey="Năm 2024"
                    fill="#2563EB"
                    radius={[4,4,0,0]}
                />

            </BarChart>
        </ResponsiveContainer>

    </div>

</div>

            <div className="card">

    <div className="chart-header">
        <h3>
    CƠ CẤU KHÁCH HÀNG
</h3>
    </div>

    <div className="pie-layout">

        {/* DONUT */}

        <div className="pie-chart-area">

            <ResponsiveContainer
                width="100%"
                height={240}
            >
                <PieChart>

                    <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={55}
                        outerRadius={85}
                        paddingAngle={2}
                        dataKey="value"
                    >
                        {pieData.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={entry.color}
                            />
                        ))}
                    </Pie>

                </PieChart>

            </ResponsiveContainer>

            <div className="donut-center">
                <div className="donut-value">
    2.156
</div>

<div className="donut-unit">
    Tổng số
</div>
            </div>

        </div>

        {/* LEGEND */}

        <div className="pie-legend">

            {pieData.map((item,index)=>(
                <div
                    key={index}
                    className="legend-item"
                >

                    <div className="legend-left">

                        <span
                            className="legend-dot"
                            style={{
                                background:item.color
                            }}
                        />

                        <span>
                            {item.name}
                        </span>

                    </div>

                    <strong>
                        <strong>
    {item.value.toLocaleString()} ({item.percent.replace(".", ",")}%)
</strong>
                    </strong>

                </div>
            ))}

        </div>

    </div>

</div>

          </div>

{/* TABLE */}
<div className="report-table-card">

    <div className="report-table-header">

        <h3>
    CHỈ TIÊU CUNG CẤP ĐIỆN
</h3>

<span>
    Đơn vị tính: kWh
</span>

    </div>

    <div className="table-wrapper">

        <table className="report-table">

            <thead>

                <tr>
    <th>STT</th>
    <th>Chỉ tiêu</th>
    <th>Tháng 05/2024</th>
    <th>Tháng 04/2024</th>
    <th>So với kỳ trước (%)</th>
    <th>Lũy kế từ đầu năm</th>
    <th>So với cùng kỳ (%)</th>
</tr>
            </thead>

            <tbody>

<tr>
    <td>1</td>
    <td className="text-left">
        Điện thương phẩm
    </td>
    <td>1.258.450</td>
    <td>1.158.680</td>
    <td className="up-value">↑ 8,6%</td>
    <td>5.892.120</td>
    <td className="up-value">↑ 6,2%</td>
</tr>

<tr>
    <td>2</td>
    <td className="text-left">
        Điện sinh hoạt
    </td>
    <td>882.150</td>
    <td>805.020</td>
    <td className="up-value">↑ 9,6%</td>
    <td>4.102.350</td>
    <td className="up-value">↑ 6,9%</td>
</tr>

<tr>
    <td>3</td>
    <td className="text-left">
        Điện sản xuất - kinh doanh
    </td>
    <td>249.680</td>
    <td>229.340</td>
    <td className="up-value">↑ 8,9%</td>
    <td>1.182.450</td>
    <td className="up-value">↑ 5,4%</td>
</tr>

<tr>
    <td>4</td>
    <td className="text-left">
        Điện hành chính sự nghiệp
    </td>
    <td>85.360</td>
    <td>78.560</td>
    <td className="up-value">↑ 8,7%</td>
    <td>392.150</td>
    <td className="up-value">↑ 4,1%</td>
</tr>

<tr>
    <td>5</td>
    <td className="text-left">
        Chiếu sáng công cộng
    </td>
    <td>41.260</td>
    <td>37.760</td>
    <td className="up-value">↑ 9,3%</td>
    <td>215.170</td>
    <td className="up-value">↑ 7,8%</td>
</tr>

<tr>
    <td>6</td>
    <td className="text-left">
        Tổn thất điện năng (%)
    </td>
    <td>3,45</td>
    <td>3,70</td>
    <td style={{color:"#DC2626",fontWeight:"600"}}>
        ↓ 0,25 điểm %
    </td>
    <td>3,60</td>
    <td className="up-value">
        ↓ 0,30 điểm %
    </td>
</tr>

</tbody>

        </table>

    </div>

</div>

{/* NOTE + FILE */}
<div className="bottom-grid">

    {/* GHI CHÚ */}
    <div className="note-card">

        <div className="section-title">
            Ghi chú
        </div>

        <div className="note-wrapper">

            <textarea
                maxLength={500}
                placeholder="Nhập ghi chú (nếu có)..."
                className="note-textarea"
            />

            <span className="note-counter">
                0/500
            </span>

        </div>

    </div>

    {/* FILE */}
    <div className="upload-card">

    <div className="section-title">
        Tài liệu đính kèm
    </div>

    <div className="upload-area">

        <div className="upload-top">

            <div className="upload-icon">
                <i className="fa-solid fa-cloud-arrow-up"></i>
            </div>

            <div className="upload-text">
                Kéo thả file vào đây hoặc
            </div>

            <label className="choose-file-btn">
                Chọn file
                <input type="file" hidden />
            </label>

        </div>

        <div className="upload-format">
            Định dạng: .pdf, .doc, .docx, .xls, .xlsx
        </div>

        <div className="upload-size">
            Dung lượng tối đa 20MB
        </div>

    </div>

</div>

</div>

          {/* ACTION */}
          <div className="action-row">

            <button className="outline-btn">
              Quay lại
            </button>

            <button className="outline-btn">
              Lưu nháp
            </button>

            <button className="primary-btn">
              Gửi báo cáo
            </button>

          </div>

        </div>

{/* RIGHT */}
<div className="report-sidebar">

    {/* THÔNG TIN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            THÔNG TIN KỲ BÁO CÁO
        </h3>

        <div className="sidebar-info-row">
            <span>Kỳ báo cáo</span>
            <strong>Tháng 05/2024</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Loại báo cáo</span>
            <strong>Báo cáo cung cấp điện</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Ngày tạo</span>
            <strong>02/06/2024 09:15</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Hạn gửi</span>
            <strong>05/06/2024 23:59</strong>
        </div>

        <div className="sidebar-info-row">
            <span>Trạng thái</span>

            <span className="status-badge warning">
                Chưa gửi
            </span>
        </div>

    </div>

    {/* TIẾN ĐỘ */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            TIẾN ĐỘ BÁO CÁO ĐIỆN LỰC
        </h3>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot active"></span>
                <span>Báo cáo cung cấp điện</span>
            </div>

            <span className="status-badge warning">
                Chưa gửi
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo sự cố, mất điện</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Báo cáo tiết kiệm điện</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Công trình điện nông thôn</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

        <div className="progress-item">

            <div className="progress-left">
                <span className="dot"></span>
                <span>Năng lượng tái tạo</span>
            </div>

            <span className="status-badge gray">
                Chưa tạo
            </span>

        </div>

    </div>

    {/* HƯỚNG DẪN */}
    <div className="sidebar-card">

        <h3 className="sidebar-title">
            TÀI LIỆU HƯỚNG DẪN
        </h3>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn lập báo cáo cung cấp điện</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Mẫu báo cáo cung cấp điện (Excel)</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo sự cố, mất điện</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-item">
            <i className="fa-regular fa-file-lines"></i>
            <span>Hướng dẫn báo cáo tiết kiệm điện</span>
            <i className="fa-solid fa-download"></i>
        </div>

        <div className="guide-footer">
            Xem tất cả
            <i className="fa-solid fa-arrow-right"></i>
        </div>

    </div>

</div>

      </div>

    </div>
  );
}

export default DienLuc;